import React from 'react'
import { LoginPage } from '@pilot-hub/ui'
import { userApi } from '@pilot-hub/api-client'
import { useAuth } from '@pilot-hub/auth'
import { useNavigate } from 'react-router-dom'

interface LoginUser {
  id: string
  benutzername: string
  vorname?: string
  nachname?: string
}

export function LoginPageFuehrung() {
  const { login } = useAuth()
  const navigate = useNavigate()
  
  return (
    <LoginPage
      module="fuehrung"
      title="Führungskräfte-Modul"
      loginEndpoint="/auth/login"
      redirectPath="/verwaltung"
      getLoginUsers={async (): Promise<LoginUser[]> => {
        const response = await userApi.getLoginFuehrung()
        return response.data as LoginUser[]
      }}
      onLogin={login}
    />
  )
}